import { Moon, Sun } from "lucide-react";
import { IconButton } from "@doculegis/shared";
import { useTheme } from "@/contexts/ThemeContext";

/** Theme control — place next to the header menu / sidebar toggle. */
export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <IconButton
      type="button"
      onClick={toggleTheme}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className="border-transparent hover:border-transparent dark:border-transparent dark:hover:border-transparent"
    >
      {isDark ? <Sun strokeWidth={1.75} /> : <Moon strokeWidth={1.75} />}
    </IconButton>
  );
}
